import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';

import { IEditUser } from './types';
import { client } from '../common/services';
import { QueryKeys } from '../common/types';
import { useSnackBar } from '../common/components/SnackBarContext';
import { DUPLICATED_EMAIL_ERROR, DUPLICATED_PHONE_ERROR } from '@bandido/shared/constants';

interface UsePatchMeProps {
  onSuccess?: () => void;
}

export const usePatchMe = ({ onSuccess }: UsePatchMeProps) => {
  const { addToast } = useSnackBar();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (data: IEditUser) => {
      const response = await client.patch('user/me', data);
      return response.data;
    },
    {
      onMutate: async () => {
        await queryClient.cancelQueries([QueryKeys.getMyUserData]);
      },
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        }
        addToast({
          message: t('auth.editUser.patchSuccess'),
          color: 'success',
        });
      },
      onError: (e: any) => {
        const errorResponse  = e.response?.data?.error;
        if (errorResponse === DUPLICATED_EMAIL_ERROR) {
          addToast({
            message: t('clients.create.createdErrorEmail'),
            color: 'error',
          });

          } else if (errorResponse === DUPLICATED_PHONE_ERROR) {
          addToast({
            message: t('clients.create.createdErrorPhone'),
            color: 'error',
          });
        } else {
          addToast({
            message: t('clients.create.createdError'),
            color: 'error',
          });
        }
      },
      onSettled: () => {
        queryClient.invalidateQueries([QueryKeys.getMyUserData]);
      },
    },
  );

  return mutation;
};
